export default __webpack_public_path__ + "assets/account-credit-desktop.png";